import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import _ from 'lodash';
import invariant from 'invariant';
import classNames from 'classnames';

import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import LoadingBlocks from 'components/forms/LoadingBlocks';
import CreditCardForm from 'components/CreditCardFormProfile';
import CreditCardCondensed from 'components/CreditCardFormProfile/Condensed';

import PaywayDataTask from 'requests/tasks/PaywayDataTask';
import ChangePaymentInfoTask from 'requests/tasks/ChangePaymentInfoTask';
import RequestManager from 'requests/RequestManager';
import { putCreditCard, postCreditCard } from './api/index';

import { GetRegion } from 'constants.js';
import { getFingerprint } from 'reducers/payments/cybersource';

class WrapperMyAccountCreditCard extends PureComponent {
  static propTypes = {
    clienteId: PropTypes.string,
    userToken: PropTypes.string,
    paywayData: PropTypes.array,
    fingerprint: PropTypes.string.isRequired,
    translations: PropTypes.object,
  };

  static defaultProps = {
    paywayData: [],
  };

  state = {
    userValues: {
      pending: true,
      form: {},
      cardsList: [],
      statesList: [],
      errors: {},
    },
    condensed: {
      cardNumber: '',
    },
    submitStates: {
      pending: false,
    },
    modifyView: false,
    modal: {
      show: false,
      msg: null,
      title: null,
      error: false,
    },
  };

  claroPagosConfig = {};
  creditCardToken = '';

  isANewCreditCard = form =>
    _.has(form, 'cardProvider') || _.has(form, 'cardNumber');

  handlerSubmit = (e, data) => this.asyncStart(data);

  asyncStart = async formCreditCard => {
    this.setState({ submitStates: { pending: true } });
    const {
      userValues: { form },
    } = this.state;
    const { clienteId, userToken } = this.props;
    const formReduced = _.reduce(
      formCreditCard,
      (formAcum, value, key) => {
        if (form[key] === value) {
          return { ...formAcum };
        }
        return { ...formAcum, [key]: value };
      },
      {},
    );
    if (_.isEmpty(formCreditCard)) return true;
    if (this.isANewCreditCard(formReduced)) {
      // when the fields changed are credit card number and/or card provider
      try {
        const resCreateCC = await this.callCreateCreditCard(
          {
            ...form,
            ...formReduced,
          },
          clienteId,
        );
        const { fingerprint } = this.props;
        const cpCreditCardToken = resCreateCC.model.tarjeta.token;
        const task = new ChangePaymentInfoTask({
          token: userToken,
          extra_params: JSON.stringify({
            cliente_id: clienteId,
            card_type: formReduced.cardProvider || form.cardProvider,
            old_token: this.creditCardToken,
            new_token: cpCreditCardToken,
            device_fingerprint: fingerprint,
          }),
        });
        const resChangePayment = await RequestManager.addRequest(task);
        const code = _.get(resChangePayment, ['response', 'code']);
        this.setState({
          modal: {
            ...this.state.modal,
            show: true,
            msg: window.utils.getMeta.translations(
              code,
              'Se ha modificado correctamente el medio de pago.',
            ),
            title: 'Congratulations!',
            error: false,
          },
          userValues: {
            ...this.state.userValues,
            form: {
              ...form,
              ...formReduced,
            },
          },
          submitStates: {
            pending: false,
          },
        });
      } catch (err) {
        this.setState({
          modal: {
            ...this.state.modal,
            show: true,
            msg: 'No se pudo realizar su operacion.',
            title: 'Oops!',
            error: true,
          },
          submitStates: {
            pending: false,
          },
        });
      }
    } else {
      this.setState({
        userValues: {
          ...this.state.userValues,
          errors: {},
        },
      });
      try {
        await this.updateCreditCard(this.creditCardToken, clienteId, {
          ...form,
          ...formReduced,
        });
        this.setState({
          modal: {
            ...this.state.modal,
            show: true,
            msg: 'Se ha modificado correctamente el medio de pago.',
            title: 'Congratulations!',
            error: false,
          },
          userValues: {
            ...this.state.userValues,
            form: {
              ...form,
              ...formReduced,
            },
          },
          submitStates: {
            pending: false,
          },
        });
      } catch (e) {
        this.setState({
          modal: {
            ...this.state.modal,
            show: true,
            msg: 'No se pudo realizar su operacion.',
            title: 'Oops!',
            error: true,
          },
          submitStates: {
            pending: false,
          },
        });
      }
    }
    return true;
  };

  callCreateCreditCard = async (form, clienteId) => {
    const tokenTarjetas = atob(
      _.get(this.claroPagosConfig, ['update_card', 'header', 'authorization']),
    );
    const getAnio = _.takeRight(form.expirationYear.split(''), 2).join('');
    const resCreditCard = await postCreditCard(
      {
        nombre: form.name,
        pan: form.cardNumber,
        cvv2: form.cardNip,
        expiracion_mes: form.expirationMonth,
        expiracion_anio: getAnio,
        direccion: {
          linea1: form.address,
          estado: form.state,
          ciudad: form.city,
          cp: form.zipCode,
          telefono: {
            numero: form.phone,
          },
        },
        cliente_id: clienteId,
        default: true,
        cargo_unico: true,
      },
      tokenTarjetas,
    );
    return {
      model: _.get(resCreditCard, 'data.data'),
    };
  };

  handlerCancel = () => {
    this.setState({
      modifyView: false,
    });
  };

  updateCreditCard = async (token, clienteId, form) => {
    const getAnio = _.takeRight(form.expirationYear.split(''), 2).join('');
    const tokenTarjetas = atob(
      _.get(this.claroPagosConfig, ['update_card', 'header', 'authorization']),
    );
    const resPutCC = await putCreditCard(
      token,
      {
        nombre: form.name,
        cvv2: form.cardNip,
        expiracion_mes: form.expirationMonth,
        expiracion_anio: getAnio,
        direccion: {
          linea1: form.address,
          estado: form.state,
          ciudad: form.city,
          cp: form.zipCode,
          telefono: {
            numero: form.phone,
          },
        },
        cliente_id: clienteId,
        default: true,
      },
      tokenTarjetas,
    );
    return {
      error: false,
      model: _.get(resPutCC, 'data.data'),
    };
  };

  fetchtPaywayData = async () => {
    try {
      const task = new PaywayDataTask(window.getConfig);
      const resPaywayData = await RequestManager.addRequest(task);
      invariant(
        Number(resPaywayData.status) === 0,
        'Payway/data Error',
        resPaywayData,
      );
      return {
        error: false,
        model: resPaywayData,
      };
    } catch (error) {
      return {
        error: true,
        model: error.response,
      };
    }
  };

  getApaValues = () => {
    const states = _.get(window.utils.getMeta.metadata('provinces_codes'), [
      GetRegion(),
      'provinces',
    ]);

    const statesList = _.map(states, ({ code, name }) => ({
      value: code,
      text: name,
    }));

    const cardRegion = _.get(
      window.utils.getMeta.metadata('creditcard_by_region'),
      [GetRegion(), 'creditcards'],
    );
    const cardsList = _.map(cardRegion, card => ({
      code: card.id,
      image: window.utils.getAsset.asset(`ic_creditcard_${card.code}`),
    }));
    return { statesList, cardsList };
  };

  cardProviderToCode(provider) {
    switch (Number(provider)) {
      case 'visa':
        return 1;
      case 'mastercard':
        return 2;
      case 'americanexpress':
        return 3;
      default:
        return 0;
    }
  }

  cardCodeToProvider(code) {
    switch (code) {
      case 1:
        return 'visa';
      case 2:
        return 'mastercard';
      case 3:
        return 'americanexpress';
      default:
        return '';
    }
  }

  componentDidMount = async () => {
    this.claroPagosConfig = _.get(
      window.utils.getMeta.metadata('claropagos_configuration'),
      [GetRegion(), 'request'],
    );
    let error = false;
    let { paywayData } = this.props;

    if (_.isEmpty(paywayData)) {
      const res = await this.fetchtPaywayData();
      error = res.error;
      paywayData = res.model.response;
    }

    if (error) {
      this.setState({
        userValues: {
          ...this.state.userValues,
          pending: false,
          form: {},
        },
      });
    } else {
      const purchaseInfo = _.find(
        paywayData,
        item => Number(item.waspurchase) === 1,
      );
      const purchaseData = _.get(
        purchaseInfo,
        ['purchase_data', 'gateway_data'],
        {},
      );

      this.creditCardToken = purchaseData.token;
      const expirationYear = purchaseData.expiration_year || '';

      const { cardsList, statesList } = this.getApaValues();
      this.setState({
        userValues: {
          ...this.state.userValues,
          pending: false,
          cardsList,
          statesList,
          form: {
            name: purchaseData.card_owner_name || '',
            cardProvider: +purchaseData.card_type || '',
            cardNumber: this.formatCreditCardTrim(
              purchaseData.card_number_display,
            ),
            cardNip: '',
            expirationMonth: purchaseData.expiration_month || '',
            expirationYear:
              expirationYear.length > 2
                ? purchaseData.expiration_year
                : `20${purchaseData.expiration_year}`,
            address: purchaseData.address || '',
            city: purchaseData.city || '',
            state: purchaseData.state || '',
            zipCode: purchaseData.zip_code || '',
            phone: purchaseData.phone_number || '',
          },
        },
        condensed: {
          cardNumber: this.formatCreditCard(purchaseData.card_number_display),
        },
      });
    }
  };

  formatCreditCard = str => `XXXX XXXX XXXX ${str.slice(-4)}`;
  formatCreditCardTrim = str => `XXXXXXXXXXXX${str.slice(-4)}`;

  showModifyView = () => {
    this.setState({
      modifyView: true,
    });
  };

  renderModal = () => {
    const classes = {
      'text-center': true,
      'full-width': true,
      fa: true,
      'fa-3x': true,
      'fa-check': !this.state.modal.error,
      'fa-times': this.state.modal.error,
    };
    const classesForIcon = classNames(classes);
    const handlerClose = () => {
      this.setState({
        modal: {
          show: false,
          msg: null,
          title: null,
          error: false,
        },
        modifyView: false,
      });
    };
    return (
      <Modal show={this.state.modal.show}>
        <Modal.Header>
          <Button className="close close-modal" onClick={handlerClose}>
            x
          </Button>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          <i className={classesForIcon} />
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{ __html: this.state.modal.msg }}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 padding-top-05">
              <button
                className={'btn btn-default btn-block'}
                role="button"
                onClick={handlerClose}
              >
                {window.utils.getMeta.translations(
                  'registro_aceptar',
                  'Aceptar',
                )}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  renderForm() {
    const cardProvider = this.cardCodeToProvider(
      this.state.userValues.form.cardProvider,
    );
    return !this.state.modifyView ? (
      <CreditCardCondensed
        cardsList={this.state.userValues.cardsList}
        cardNumber={this.state.condensed.cardNumber}
        cardLegend={window.utils.getMeta.translations(
          'profile_pay_credit_card_number',
          'Numero de tarjeta.',
        )}
        textChangeView={'Modificar'}
        onPressChangeView={this.showModifyView}
      />
    ) : (
      <CreditCardForm
        onSubmitForm={this.handlerSubmit}
        onCancelForm={this.handlerCancel}
        isSubmitting={this.state.submitStates.pending}
        formValues={this.state.userValues.form}
        cardsList={this.state.userValues.cardsList}
        statesList={this.state.userValues.statesList}
        translations={this.props.translations}
      />
    );
  }

  render() {
    const {
      userValues: { pending },
    } = this.state;
    return (
      <div>
        {pending ? <LoadingBlocks /> : this.renderForm()}
        {this.renderModal()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fingerprint: getFingerprint(state),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(WrapperMyAccountCreditCard);
